/* TS 系列 —— 大圖影片的播放控制
   只做一件事：捲到看得見才開始播、捲走就暫停。

   為什麼要這支：影片標籤寫 preload="none"，不主動叫它播就一個位元組都不下載。
   首頁可能同時有三段各放一支影片，讓瀏覽器自己 autoplay 等於一進站抓三支，
   把使用者的頻寬燒光（尤其手機）。捲到才播，沒看到的那幾段就完全沒有成本。 */
(function () {
  if (window.__tsSeriesVid) return;   // 每個 section 各載一次 script，要擋住重複執行
  window.__tsSeriesVid = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    var vids = document.querySelectorAll('.ts-series__vid');
    if (!vids.length) return;

    // 使用者設定「減少動態效果」就整支不播，停在封面圖
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          // play() 會回 Promise，被瀏覽器擋下時要吃掉例外，不然 console 會噴紅字
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify 編輯器換內容時要重掛
  document.addEventListener('shopify:section:load', function () {
    window.__tsSeriesVid = false; boot(); window.__tsSeriesVid = true;
  });
})();
